import type { FixedPricing } from '@weft/types';
import { PRICING_MODELS } from '@weft/types';
import { isNullOrUndefined, raise, raiseUnreachable } from '@weft/utils';

export function getFixedChargePriceForAllIntervals(pricing: FixedPricing, numOfIntervals: number) {
  const price = getFixedChargePrice(pricing);

  switch (pricing.pricingModel) {
    case PRICING_MODELS.Commission:
      return 0;
    case PRICING_MODELS.FixedOneTime:
    case PRICING_MODELS.Refund:
      return price;
    case PRICING_MODELS.FixedPerUnit:
      return pricing.priceConfiguration.upfrontPay ? pricing.priceConfiguration.units * price * numOfIntervals : pricing.priceConfiguration.units * price;
    case PRICING_MODELS.Installments:
      return price * pricing.priceConfiguration.installments;
    case PRICING_MODELS.Subscription:
      return price * numOfIntervals;
    case PRICING_MODELS.CommercialTerms:
      return price;
    default:
      return raiseUnreachable(pricing);
  }
}

export function getFixedChargePrice(pricing: FixedPricing) {
  if (pricing.pricingModel === PRICING_MODELS.Commission) {
    return 0;
  }

  const price = pricing.priceConfiguration?.price;

  if (isNullOrUndefined(price)) {
    return raise(`Price is undefined for fixed pricing: ${JSON.stringify(pricing, null, 2)}`);
  }

  return price;
}